import { isOrgaForfaitActive } from '@shared';

/**
 * Résout l'organisation cible du blog.
 * 1 rattachement → implicite.
 * Plusieurs → `requestedOrganizationId` (query) ou l'unique Forfait actif.
 * Ambigu → null (l'écran affiche le sélecteur).
 */
export function resolveOrganizerBlogMembership<
  T extends {
    organizationId: number;
    organization?: {
      name?: string | null;
      plan?: Parameters<typeof isOrgaForfaitActive>[0];
      subscriptionStatus?: Parameters<typeof isOrgaForfaitActive>[1];
    } | null;
  },
>(memberships: T[] | undefined, requestedOrganizationId?: number): T | null {
  const list = memberships ?? [];
  if (list.length === 0) return null;

  if (requestedOrganizationId != null) {
    return list.find(m => m.organizationId === requestedOrganizationId) ?? null;
  }

  if (list.length === 1) return list[0];

  const forfait = list.filter(m => isOrgaForfaitActive(m.organization?.plan, m.organization?.subscriptionStatus));
  if (forfait.length === 1) return forfait[0];
  return null;
}

export function parseRequestedOrganizationId(raw: string | null): number | undefined {
  if (!raw) return undefined;
  const id = Number(raw);
  return Number.isInteger(id) && id > 0 ? id : undefined;
}
